import {search as searchApi} from '../../api';

export const REQUEST_TAG_ACTION = 'REQUEST_TAG_ACTION';
export const RECEIVE_TAG_SUCCESS = 'RECEIVE_TAG_SUCCESS';
export const RECEIVE_TAG_FAILURE = 'RECEIVE_TAG_FAILURE';

const requestTags = () => ({
  type: REQUEST_TAG_ACTION,
});

const receiveTagsSuccess = (tags) => ({
  type: RECEIVE_TAG_SUCCESS,
  payload: {
    tags
  },
});

const receiveTagsFailure = (error) => ({
  type: RECEIVE_TAG_FAILURE,
  payload: {
    error
  },
});

export const getTags = (text) =>
  (dispatch) => {
    dispatch(requestTags(text));

    return searchApi.tags(text)
      .then( (response) => {
        dispatch(receiveTagsSuccess(response.data));
      }).catch( (error) => {
        dispatch(receiveTagsFailure(error));
      });
  }



// WEBPACK FOOTER //
// ./src/search/actions/tagActions.js